// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._397PbEcEuKO1-f {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-top: 8px;\n}\n._397PbEcEuKO1-f button {\n  flex: 1;\n  overflow: hidden;\n  margin-right: 8px;\n}\n._397PbEcEuKO1-f button:last-child {\n  margin-right: 0;\n}\n._1QMlhblIEMKL3O select {\n  width: unset;\n}\n._1Zpe7FavBA8hB1 {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  margin-top: 8px;\n}\n._1Zpe7FavBA8hB1 div {\n  flex: 1;\n  overflow: hidden;\n  margin-right: 8px;\n}\n._1Zpe7FavBA8hB1 div:last-child {\n  margin-right: 0;\n}\n._1Zpe7FavBA8hB1 label {\n  margin-top: 0;\n}\n._1Zpe7FavBA8hB1 input {\n  width: 100%;\n}\n._5DzCUBw9EsYG1V {\n  color: #5E6C84;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttons": "_397PbEcEuKO1-f",
	"pikaday": "_1QMlhblIEMKL3O",
	"inputFields": "_1Zpe7FavBA8hB1",
	"reminderClarification": "_5DzCUBw9EsYG1V"
};
export default ___CSS_LOADER_EXPORT___;
